let redirects = undefined;
const defaultLang = 'is';

function fixRelative(url) {
  if (!url) {
    return '';
  }

  const lowered = url.toLocaleLowerCase();

  // Prismic UI will allow OR add https:// for relative links in their UI
  if (lowered.startsWith('https:///')) {
    return url.substr('https://'.length);
  }

  if (lowered.startsWith('http:///')) {
    return url.substr('http://'.length);
  }

  return url;
}

/**
 * Resolves for inlined prismic objects and from the API
 */
function linkResolver(doc, useRedirects = true) {
  if (doc == null) {
    return '/'; // To fail gracefully or blow up, that is the question.
  }

  // Looks like we're being passed a GarphQL object, transform that
  if (typeof doc.__typename === 'string' && doc.__typename) {
    return linkResolverForGraphqlObject(doc, useRedirects);
  }

  if (doc.link_type || doc._link_type) {
    switch (doc.link_type || doc._link_type) {
      case 'Web':
        return fixRelative(doc.url);
      case 'Media':
        return fixRelative(doc.url);
      default:
        if (doc.url) {
          return fixRelative(doc.url);
        }
    }
  }

  /**
   * Pull in the redirects we create during build time. This tries to resolve
   * them at build time instead of having them be redirect at runtime.
   * E.g. if we have a link to "/fyrir-honnudi/honnunarsjodur" it would be
   * rendered as "/page/honnunarsjodur" in source but redirected on the client.
   * This fixes that
   *
   * @see ./gatsby-node.js
   */
  if (useRedirects && redirects === undefined) {
    try {
      redirects = require('../../.cache/redirects.json');
    } catch (e) {
      redirects = null;
      // tslint:disable-next-line: no-console
      console.warn('Unable to load .cache/redirects.json', e);
    }
  }

  let lang = '';

  // if it's not the default lang, we link to that lang
  if (doc._meta && doc._meta.lang && doc._meta.lang.toLocaleLowerCase() !== defaultLang) {
    lang = `/${doc._meta.lang.toLocaleLowerCase().replace('en-us', 'en')}`; // TODO more elegant way?
  }

  if (doc.type) {
    switch (doc.type) {
      /**
       * "event" is a real type, but a "subtype" of articles (it's a select type on the prismic
       * mask). This will fail, e.g. for links inside richtext.
       * TODO Fix bug above!
       */
      // case 'event':
      //   return `${lang}/vidburdir/${doc.uid}`;
      case 'event':
      case 'article':
        return `${lang}/ha-frettir/${doc.uid}`;
      case 'page':
        if (redirects) {
          const found = redirects.find(i => i.fromPath === `${lang}/page/${doc.uid}`);
          if (found) {
            return found.toPath;
          }
        }
        return `${lang}/page/${doc.uid}`;
      case 'project':
        return `${lang}/verkefni/${doc.uid}`;
      case 'association':
        return `${lang}/fagfelog/${doc.uid}`;
      case 'homepage':
        return `${lang}/`;
      default:
        if (doc.uid) {
          return `${doc.uid}`;
        }

        return `/${doc.type}`;
    }
  }

  return '/';
}

function linkResolverForGraphqlObject(doc, useRedirects = true) {
  if (doc == null) {
    return '/';
  }

  const { __typename, _meta = {}, url } = doc;
  const { uid = '', type = '' } = _meta;

  // Map to the way Prismic represents docs to linkResolver, like for Link and RichText
  const mappedDoc = { _meta };

  // TODO figure out all the different cases...
  switch (__typename || type) {
    case 'PRISMIC__ExternalLink':
    case '_ExternalLink':
      mappedDoc.link_type = 'Web';
      mappedDoc.url = url;
      break;
    case 'PRISMIC__ImageLink':
    case 'PRISMIC__FileLink':
    case '_ImageLink':
    case '_FileLink':
      mappedDoc.link_type = 'Media';
      mappedDoc.url = url;
      break;
    case 'PRISMIC_Article':
    case 'Article':
    case 'article':
      // See note above about events and articles
      mappedDoc.type = doc.type && doc.type === 'event' ? 'event' : 'article';
      mappedDoc.uid = uid;
      break;
    case 'PRISMIC_Page':
    case 'Page':
    case 'page':
      mappedDoc.type = 'page';
      mappedDoc.uid = uid;
      break;
    case 'PRISMIC_Project':
    case 'Project':
    case 'project':
      mappedDoc.type = 'project';
      mappedDoc.uid = uid;
      break;
    case 'PRISMIC_Association':
    case 'Association':
    case 'association':
      mappedDoc.type = 'association';
      mappedDoc.uid = uid;
      break;
    case 'PRISMIC_External_cta':
    case 'externalCta':
    case 'External_cta':
      mappedDoc.link_type = 'Web';
      mappedDoc.url = url;
      break;
    default:
      break;
  }

  return linkResolver(mappedDoc, useRedirects);
}

module.exports = {
  fixRelative,
  linkResolver,
};
